import { ComponentProps, PropsWithoutRef, ReactNode, useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@altimateai/lego";
import { cn } from "@/lib/utils";

function BetterPopover({
  id,
  trigger,
  render,
  popoverContentProps,
}: PropsWithoutRef<{
  id: string;
  trigger: ReactNode;
  render: (_args: { close: () => void }) => ReactNode;
  popoverContentProps?: ComponentProps<typeof PopoverContent>;
}>) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div
          id={id}
          tabIndex={0}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {trigger}
        </div>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        {...popoverContentProps}
        className={cn("al-w-max", popoverContentProps?.className)}
      >
        <div>
          {render({
            close: () => {
              setIsOpen(false);
            },
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export { BetterPopover };
